import t, { Intl } from '@jetshop/intl';
import useLoginFields from '@jetshop/core/components/Auth/useLoginFields';
import useSignupForm from '@jetshop/core/components/Auth/useSignupForm';
import { TrendButton } from '@jetshop/ui/Button';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import React, { useContext, useEffect, useState } from 'react';
import Input, { ConsentBox } from '../../Forms/Input';
import { GlobalError } from '../../Forms/GlobalError';
import { SignupFormikContext } from '@jetshop/core/components/Auth/signup-context';
import { theme } from '../../Theme';
import { Errors } from '../Voyado/VoyadoSignup';



const sectionStyle = css`
  margin-top: 2em;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  ${theme.below.lg} {
      margin-top: 1rem;
      grid-template-columns: 1fr;
    }
  .suggest {
    margin-top: -28px;
    padding: 0.5rem;
    margin-bottom: 1.5rem;
    font-size: 14px;
    background: #ffe58d;
    border-radius: 0 0 4px 4px;
    span {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .consent-and-submit {
    grid-column: 1 / 3;
    max-width: 500px;
    align-self: center;
    justify-self: center;
    ${theme.below.lg} {
      grid-column: 1 / 2;
    }
    button {
      min-width: 300px;
    }
  }
  .submit-and-errors {
    max-width: 300px;
    align-self: center;
    justify-self: center;
  }
`;

const StyledTrendButton = styled(TrendButton)`
  align-self: center;
  background: ${theme.colors.accent};
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  justify-self: center;
;
  &:disabled {
    background-color: #808080;
  }
`;

const missingRequiredFields = ({
  emailAddress,
  mobilePhone,
  password,
 
}) => {
  return !emailAddress ||
    !mobilePhone ||
    !password;
};

export default function LoginFields({
  emailCheck,
  setEmailCheck,
  emailChecker,
  ...props
}) {
  const { fields } = useLoginFields();
  const { globalError, isSubmitting, isSignupError, ...rest } = useSignupForm();
  const {
    formik: { setFieldValue, values, errors, handleSubmit }
  } = useContext(SignupFormikContext);
  const [consent, setConsent] = useState(false);
  function focusSection() {
    if (!props.isActive) props.setActiveSection('loginFields');
  }

  const setSuggestion = () => {
    setFieldValue('emailAddress', emailCheck[0].corrected);
    setEmailCheck([]);
  };

  useEffect(() => {
    setEmailCheck(emailChecker(values?.emailAddress));

  }, [values?.emailAddress]);
  const hasMissingFields = missingRequiredFields(values);
  const hasErrors = Object.keys(errors).length > 0;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (values.countryCode === 'SE' && values.mobilePhone.startsWith('0')) {
      setFieldValue('mobilePhone', `+46${values.mobilePhone.slice(1)}`);
    }
    handleSubmit();
  };

  return (
    <section
      className={cx('section', props.isActive ? 'active' : null, sectionStyle)}
    >
      {globalError && (
        <GlobalError style={{ marginBottom: '2em' }}>{globalError}</GlobalError>
      )}

      {fields.map(field => {
        if (field.id === 'emailAddress') {
          return (
            <Intl>
            {t => (
            <>
              <Input 
                {...field.inputProps} 
                onFocus={focusSection} 
                placeholder={t('Write your email here')} />
              {emailCheck?.length > 0 && (
                <ul className="suggest">
                  <li>
                    {t('Did you mean')}{' '}
                    <span onClick={setSuggestion}>
                      {emailCheck[0].corrected}
                    </span>
                    ?
                  </li>
                </ul>
              )}
            </>
            )}
            </Intl>
          );
        }
        if (field.id === 'password') {
          return (
          <Intl>
            {t => (
            <Input 
              {...field.inputProps} 
              onFocus={focusSection} 
              placeholder={t('Write your password here')} />
              )}
          </Intl>
          )
        }
      })}
      <div className="consent-and-submit">
        <ConsentBox label={t('User agreement')} required={true} consent={consent} setConsent={setConsent} />
        <div className="submit-and-errors">
          <StyledTrendButton
            disabled={!consent || hasMissingFields || isSubmitting || hasErrors}
            type="submit"
            onClick={handleFormSubmit}
          >
            {isSubmitting ? t('Hold on a moment…') : t('Become a member')}
          </StyledTrendButton>
          <Errors />
        </div>
      </div>
    </section>
  );
}
